import { cn } from "@/lib/utils";

const STYLES = {
  green: {
    chip: "bg-success-soft text-success border-success/30",
    dot: "bg-success",
    label: "Green"
  },
  amber: {
    chip: "bg-warning-soft text-warning border-warning/30",
    dot: "bg-warning",
    label: "Amber"
  },
  red: {
    chip: "bg-destructive-soft text-destructive border-destructive/30",
    dot: "bg-destructive",
    label: "Red"
  },
  na: {
    chip: "bg-secondary text-muted-foreground border-border",
    dot: "bg-border",
    label: "N/A"
  },
  unknown: {
    chip: "bg-secondary text-muted-foreground border-border",
    dot: "bg-muted-foreground",
    label: "Unanswered"
  }
};

export function RagChip({ rag, children, className }) {
  const style = STYLES[rag] || STYLES.unknown;
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-sm border px-2 py-0.5 font-mono-label text-[10px] uppercase tracking-[0.18em]",
        style.chip,
        className
      )}
    >
      <span className={cn("h-1.5 w-1.5 rounded-full", style.dot)} />
      {children || style.label}
    </span>
  );
}

export function RagDot({ rag, className }) {
  const style = STYLES[rag] || STYLES.unknown;
  return <span className={cn("h-2 w-2 shrink-0 rounded-full", style.dot, className)} />;
}

export function ragLabel(rag) {
  return (STYLES[rag] || STYLES.unknown).label;
}
